import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LoggingService } from './logging.service';
import { AaosBaseService } from './aaos-base.service';
import { OverviewModel } from '@shared/models/data/overview-model';
import { ProductModel } from '@shared/models/data/product-model';
import { Constants } from './constants';
import { RouteNames } from 'src/app/routing/route-utils';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService extends AaosBaseService {

  constructor(protected _h: HttpClient,
    protected _l: LoggingService,
     ) {
    super(_l, _h);
  }

  getOiteProduct(overviewModel: OverviewModel): ProductModel {
    const oiteProduct = overviewModel.products.find(product => product.shortName === Constants.ProductShortName.OITE);
    return oiteProduct;
  }

  getResidentCurriculum(overviewModel: OverviewModel): ProductModel {
    const resCurModel = overviewModel.products.find(product => product.shortName === Constants.ProductShortName.ROCK);
    return resCurModel;
  }

  productPathFinder(productShortName: string) {
    switch (productShortName) {
      case Constants.ProductShortName.ROCK: {
         return RouteNames.rock;
         break;
      }
      case Constants.ProductShortName.OITE: {
        return RouteNames.oite;
         break;
      }
      default: {
         break;
      }
   }
  }

  getIsAuthenticated(): Observable<boolean> {
    const isAuth = this.http.get(Constants.ApiUrl.IsAuthenticated)
      .pipe(
        map((response: any) => {
          if ((!response)) {
            const error = response.error;
            throw new Error();
          }
          return response;
        }),
        catchError(response => this.handleError(response)),
        map((response: boolean) => {
          return response;
        })
      );
    return isAuth;
  }

}
